import type { LucideIcon } from "lucide-react";
import { FACET_WS } from "../notebook-details/analytics/facet-workspace-theme";

export type FacetViewJsonMode = "view" | "json";

export function facetViewJsonTabClass(active: boolean): string {
  return `inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-[12px] font-semibold transition-colors ${
    active
      ? "bg-white text-slate-900 shadow-sm"
      : "text-slate-500 hover:text-slate-700"
  }`;
}

export const FACET_VIEW_JSON_TABLIST_CLASS =
  "inline-flex rounded-xl p-1 shadow-inner";

export interface FacetViewJsonToggleProps {
  mode: FacetViewJsonMode;
  onMode: (mode: FacetViewJsonMode) => void;
  viewLabel: string;
  jsonLabel: string;
  ViewIcon: LucideIcon;
  JsonIcon: LucideIcon;
  /** Optional accessible name for the tablist (e.g. chart strip). */
  tablistAriaLabel?: string;
}

export default function FacetViewJsonToggle({
  mode,
  onMode,
  viewLabel,
  jsonLabel,
  ViewIcon,
  JsonIcon,
  tablistAriaLabel,
}: FacetViewJsonToggleProps) {
  return (
    <div
      className={FACET_VIEW_JSON_TABLIST_CLASS}
      style={{ background: FACET_WS.segmentTrack }}
      role="tablist"
      {...(tablistAriaLabel != null ? { "aria-label": tablistAriaLabel } : {})}
    >
      <button
        type="button"
        role="tab"
        aria-selected={mode === "view"}
        onClick={() => onMode("view")}
        className={facetViewJsonTabClass(mode === "view")}
      >
        <ViewIcon size={14} strokeWidth={2} aria-hidden />
        {viewLabel}
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={mode === "json"}
        onClick={() => onMode("json")}
        className={facetViewJsonTabClass(mode === "json")}
      >
        <JsonIcon size={14} strokeWidth={2} aria-hidden />
        {jsonLabel}
      </button>
    </div>
  );
}
